@import 'styles/mixins';
@import 'styles/variables';

.scrollContainer {
  @include thinScrollbar;
  height: 100%;
  overflow: auto;
}
